if (typeof NingBoJQuery == 'undefined') {
  const NingBoJQuery = $;
}

var crm_token = "";
var re_order_number = "0";
var shopify_url = shopify_domain;

jQuery(document).ready(function () {});

function tikTokTracking(eventType) {

  
  var contents = [];
  var totalValue = 0.0; // This will store the total value of the cart
  $.ajax({
    url: "/cart.json",
    dataType: 'json',
    method: "GET",
    cache: false,
    async: false,
    complete: function (xhr) {
      try {
        xhr = xhr.responseJSON;

        // Process each item for the 'data' array as before
        $.each(xhr['items'], function (index, items) {

          // Your existing code
          // ... (push to the data array as you did before)

          // Transform for TikTok contents format
          contents.push({
            content_id: String(items["variant_id"]),
            content_type: "product", // Assuming all are products
            description: items["title"],
            content_category: "", // You'll need to define or fetch this
            quantity: items["quantity"],
            brand: "", // You'll need to define or fetch this
            value: (items["price"] / 100).toFixed(2)
          });


          // Update the totalValue
          totalValue += parseFloat(items["price"]) * items["quantity"];

        });
        console.log("contents", contents);

        ttq.track(eventType, {
          value: (totalValue / 100).toFixed(2), // Use the calculated total value
          currency: "USD", // Replace or dynamically retrieve based on your JSON data
          contents: contents
        });
      } catch (error) {
        // Handle the error appropriately
        console.error("Error processing cart data:", error);
      }
    }
  });


}


function snapPixelTracking(eventType) {
  try {
    console.log("snap pixel called ",eventType);
    var item_ids = [];
    var snapTotalValue = 0.0; // This will store the total value of the cart
    $.ajax({
      url: "/cart.json",
      dataType: 'json',
      method: "GET",
      cache: false,
      async: false,
      complete: function (xhr) {
        try {
          xhr = xhr.responseJSON;

          // Process each item for the 'data' array as before
          $.each(xhr['items'], function (index, items) {

            // Your existing code
            // ... (push to the data array as you did before)

            // Transform for TikTok contents format
            item_ids.push(
              String(items["variant_id"]),
            );

            // Update the totalValue
            snapTotalValue += parseFloat(items["price"]) * items["quantity"];

          });

        

         
          if (eventType == "START_CHECKOUT") {
            snaptr('init', '19c647e3-7c77-4076-9019-670b019702da', {
              'user_email': $('#email').val()
            });
          }

          snaptr('track', eventType, {
            price: (snapTotalValue / 100).toFixed(2), // Use the calculated total value
            currency: "USD", // Replace or dynamically retrieve based on your JSON data
            item_ids: item_ids,
            number_items: item_ids.length
          });
        } catch (error) {
          // Handle the error appropriately
          console.error("Error processing cart data:", error);
        }
      }
    });
  } catch (e) {
    console.log(e);
  }

}

function TP(email) {
  if (!email || !window.TriplePixel) {setTimeout(TP, 400); return;}
  TriplePixel("Contact", {email: email});
}

$(document).on('click', '#crm_checkoutButton_verify_email', function (e) {
  $("#checkout_error").html("");
  if (!validate_form(e)) {
    return;
  }
  // const customerInfo = {
  //   email: $('#email').val()
  // };

  $('.section__summary__top .email').html($('#email').val());

  // localStorage.setItem('customerEmail', JSON.stringify(customerInfo));

  $('.step2').show().addClass('active');
  $('.step1').hide().removeClass('active');
  $('.step3').hide().removeClass('active');
  $('.step4').hide().removeClass('active');
  $('.step5').hide().removeClass('active');

  $(window).scrollTop(0);
  showCartLoader();
  loadCart();
  //localStorage.setItem('isEditCustomerEmail', false);
});

$(document).on('click', '#crm_checkoutButton_verify_phone', function (e) {
  $("#checkout_error").html("");
  if (!validate_form(e)) {
    return;
  }
  // const customerInfo = {
  //   email: $('#email').val(),
  //   phone: $('#phone').val()
  // };
  $('.section__summary__top .email').html($('#email').val());
  $('.section__summary__top .address-phone').html($('#phone').val());

  // localStorage.setItem('customerPhone', JSON.stringify(customerInfo));
  $('.step3').show().addClass('active');
  $('.step1').hide().removeClass('active');
  $('.step2').hide().removeClass('active');
  $('.step4').hide().removeClass('active');
  $('.step5').hide().removeClass('active');

  $(window).scrollTop(0);
  showCartLoader();
  loadCart();
  // localStorage.setItem('isEditShippingInfo', false);
});

$(document).on('click', '#crm_checkoutButton_capture_customer_info', function (e) {
  $("#checkout_error").html("");
  console.log("checkout type ", $("#checkout_type").val());
  if ($("#checkout_type").val() == 2) {
    console.log("checkout type1 ", $("#crm_checkoutButton_capture_customer_info").html());
    if ($("#crm_checkoutButton_capture_customer_info").html().indexOf("Agree") != -1) {
      console.log("checkout type2 ", $("#checkout_type").val());
      $('#agree_checkbox').prop('checked', true);

      $("#crm_checkoutButton_capture_customer_info").html("Continue");
      return;
    }
  }

  if (!validate_form(e)) {
    return;
  }


  $('.section__summary__top .email').html($('#email').val());
  $('.section__summary__top .address-name').html($('#first_name').val() + ' ' + $('#last_name').val());
  if ($('#shipping_address2').val() != '') {
    $('.section__summary__top .address-address1').html($('#shipping_address1').val() + ', ' + $('#shipping_address2').val());
  } else {
    $('.section__summary__top .address-address1').html($('#shipping_address1').val());
  }
  $('.section__summary__top .address-city').html($('#shipping_city').val());
  $('.section__summary__top .address-province_code').html($('#shipping_province').val());
  $('.section__summary__top .address-zip').html($('#shipping_zip').val());
  $('.section__summary__top .address-translated_country_name').html($('#shipping_country').val());
  $('.section__summary__top .address-phone').html($('#phone').val());
  if ($('input[name="billing_address"]:checked').val() == 0) {} else {
    $('.billing_address_wrap').html('<strong>Billing address</strong><br/><p class="email">' + $('#email').val() + '</p><p class="address"><span class="address-name"> ' + $('input[name="customer[billing_address][first_name]"]').val() + ' ' + $('input[name="customer[billing_address][last_name]"]').val() + '</span><br><span class="address-address1">' + $('#billing_address1').val() + '</span><br><span class="address-city">' + $('#billing_city').val() + '</span>, <span class="address-province_code">' + $('#billing_province').val() + '</span>, <span class="address-zip">' + $('#billing_zip').val() + '</span><br> <span class="address-translated_country_name">' + $('#billing_country').val() + '</span> </p>');
  }
  signup_api_call();
});

function signup_api_call() {
  var checkout_type = $("#checkout_type").val();
  var data = $("#checkout_form").serializeArray();

  $.ajax({
    url: "/cart.json",
    dataType: 'json',
    method: "GET",
    cache: false,
    async: false,
    complete: function (xhr) {
      try {
        xhr = xhr.responseJSON;
        $.each(xhr['items'], function (index, items) {

          data.push({
            name: 'cart[line_items][' + (index + 1) + '][variant_id]',
            value: items["variant_id"]
          });
          data.push({
            name: 'cart[line_items][' + (index + 1) + '][title]',
            value: items["title"]
          });
          data.push({
            name: 'cart[line_items][' + (index + 1) + '][price]',
            value: items["price"]
          });
          data.push({
            name: 'cart[line_items][' + (index + 1) + '][quantity]',
            value: items["quantity"]
          });

        });
      } catch (error) {

      }
    }
  });

  data.push({
    name: 'apiusername',
    value: apiUsername
  });
  data.push({
    name: 'apipassword',
    value: apiPassword
  });
  data.push({
    name: 'action_type',
    value: 'capture_customer_info'
  });
  data.push({
    name: 'shopify_url',
    value: shopify_url
  });
  data.push({
    name: 'token',
    value: crm_token
  });

  
  $.ajax({
    url: api_url,
    dataType: 'json',
    method: "POST",
    data: data,
    cache: false,
    complete: function (xhr, textStatus) {
      var response = xhr.responseJSON;

      crm_token = response.token;

      if (xhr.status == 200 && response.success != false) {

        $("#cart-subtotal").html("<span class='money'>" + Shopify.formatMoney(response.printing.sub_total, money_format) + "</span>");
        $("#shipping-amount").html("<span class='money'>" + Shopify.formatMoney(response.printing.shipping, money_format) + "</span>");
        $("#fees-amount").html("<span class='money'>" + Shopify.formatMoney(response.printing.fee, money_format) + "</span>");
        $('#grand-total').html('<strong><span class="money">' + Shopify.formatMoney(response.printing.grand_total, money_format) + '</span></strong>');
        $('#nav-grand-total').html('<strong><span class="money">' + Shopify.formatMoney(response.printing.grand_total, money_format) + '</span></strong>');

        TP($('#email').val());

        if (checkout_type == 4) {
          $('.step1').hide().removeClass('active');
          $('.step2').hide().removeClass('active');
          $('.step3').hide().removeClass('active');
          $('.step4').hide().removeClass('active');
          $('.step5').show().addClass('active');
          $("#shopify-section-checkoutPage-4").show();
        } else {
          $('.step1').hide().removeClass('active');
          $('.step2').show().addClass('active');

        }

        snapPixelTracking('START_CHECKOUT');

        $(window).scrollTop(0);
        showCartLoader();
        loadCart();
        localStorage.setItem('isEditShippingInfo', false);
        check_rush_my_order(rush_my_order);

      } else if (xhr.status == 200 && response.success == false) {
        hideButtonLoader('.uni-complete-order-btn');

        if (checkout_type == 4) {
          if (response.message.indexOf("Phone") != -1) {
            $('.step1').hide().removeClass('active');
            $('.step2').show().addClass('active');
            $('.step3').hide().removeClass('active');
            $('.step4').hide().removeClass('active');
            $('.step5').hide().removeClass('active');
            $(window).scrollTop(0);
          } else if (response.message.indexOf("Email") != -1) {
            $('.step1').show().addClass('active');
            $('.step2').hide().removeClass('active');
            $('.step3').hide().removeClass('active');
            $('.step4').hide().removeClass('active');
            $('.step5').hide().removeClass('active');
            $(window).scrollTop(0);
          }
        }
        if (response.message) {
          showFormErrors(response.message);
        }
        if (response.error) {
          var error = '<div class="toasted toasted-primary error" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1; transform: translateY(-35px);"><i aria-hidden="true" class="fa fa-exclamation-circle"></i>' + response.error + '<a class="action ripple icon"><i class="fa fa-times"></i></a></div>';
          $('#checkout_error').html(error);
        }
      }

    }
  });


}


$(document).on('click', '#closeBtn', function (e) {

  $("#customPopup").hide();
});

$(document).on('click', '#crm_checkoutButton_payment', function (e) { 

  
  $('.validation_error').removeClass('error');
  $('label.error').remove();
  $("#checkout_error").html("");
  e.preventDefault();

  if (!NingBoJQuery("#checkout_form").valid()) {
    return;
  }


  showButtonLoader('.uni-complete-order-btn');
  $('#checkout_error').html('');

  $.ajax({
    url: '/cart.js',
    dataType: "json",
    cache: false,
    success: function (cart) {
      if (cart.item_count == 0) {
        location.href = '/cart';
      } else {

     
        var data = $("#checkout_form").serializeArray();
        var counter = 0;
        var cart_item_count = 0;
        var tick_upsells_product = 0;
        var tick_upsells_product_count = 0;

        var query_paameter = getUrlVarsCheckout(location.search);
        var product_array = [];
        var discount_percent = 0;

        if (query_paameter.products != undefined) {
          product_array = query_paameter.products.split(',');
        }

        $.each(cart.items, function (index, item) {

          price = item.price;

          if (checkValue(item.id, upsell_product_arr) != "Exist") {
            if ($('#signup_membership').is(':checked')) {} else {
              price = (product_custom_price * 100) + (item.price);
            }
            cart_item_count += item.quantity;
          }
          if (item.product_type == "upsell_type" || item.product_type == "free_gift") {
            tick_upsells_product_count += item.quantity;
          }

          var price = price / 100;

          if (product_array.indexOf('' + item.id + '') !== -1) {
            if (item.quantity == 2) {
              discount_percent = 10;
            } else if (item.quantity >= 3) {
              discount_percent = 15;
            }
            var product_line_price = item.price;

            price = parseFloat((product_line_price - (product_line_price / 100) * (discount_percent)));
            price = price / 100;
          }

          data.push({
            name: 'order[line_items][' + index + '][variant_id]',
            value: item.variant_id
          });
          data.push({
            name: 'order[line_items][' + index + '][title]',
            value: item.title
          });
          data.push({
            name: 'order[line_items][' + index + '][price]',
            value: price
          });
          data.push({
            name: 'order[line_items][' + index + '][quantity]',
            value: item.quantity
          });

          counter++
        });


        var payment_type = 'capture';

        if ($('#signup_membership').is(':checked')) {

          payment_type = 'subscription';

          data.push({
            name: 'order[line_items][' + counter + '][variant_id]',
            value: membership_product_id
          });
          data.push({
            name: 'order[line_items][' + counter + '][title]',
            value: membership.title
          });
          data.push({
            name: 'order[line_items][' + counter + '][price]',
            value: membership.price
          });
          data.push({
            name: 'order[line_items][' + counter + '][quantity]',
            value: membership.quantity
          });
        }

        if (total_fee > 0) {
          data.push({
            name: 'fee_percent',
            value: fee_percent
          });
          data.push({
            name: 'fees',
            value: total_fee
          });
        }

        var ship_method_ele = $("input[name='shipping_method']:checked");
        var shipping_code = ship_method_ele.data('code');
        var shipping_price = ship_method_ele.data('price');
        var shipping_title = ship_method_ele.data('title');

        var shipping_method = get_selected_shipping_method();

        console.log(tick_upsells_product_count);
        cart_item_count = cart_item_count - tick_upsells_product_count;

        var shipping_amt = cart_item_count * shipping_custom_amount;
        var shipping_amt_final = shipping_amt.toFixed(2);

        var shipping_method_code = shipping_method.code;
        var shipping_method_name = shipping_method.name;
        if (shipping_method_code == '' || typeof shipping_method_code == 'undefined') {
          shipping_method_code = 'Standard';
        }
        if (shipping_method_name == '' || typeof shipping_method_name == 'undefined') {
          shipping_method_name = 'Standard';
          data.push({
            name: 'shipping_method',
            value: 'Standard'
          });
        }

        data.push({
          name: 'order[shipping_lines][0][code]',
          value: shipping_method_code
        });
        data.push({
          name: 'order[shipping_lines][0][price]',
          value: shipping_amt_final
        });
        data.push({
          name: 'order[shipping_lines][0][title]',
          value: shipping_method_name
        });

        if (cart_discount.applies_to) {

          if (cart_discount.applies_to == 'shipping') {

            data.push({
              name: 'order[discount_codes][0][amount]',
              value: '0'
            });
            data.push({
              name: 'order[discount_codes][0][type]',
              value: 'fixed'
            });

          } else {
            data.push({
              name: 'order[discount_codes][0][code]',
              value: cart_discount.code
            });
            data.push({
              name: 'order[discount_codes][0][amount]',
              value: cart_discount.value
            });
            data.push({
              name: 'order[discount_codes][0][type]',
              value: cart_discount.value_type
            });
          }
          data.push({
            name: 'order[discount_codes][0][code]',
            value: cart_discount.code
          });
          data.push({
            name: 'order[discount_applies_to]',
            value: cart_discount.applies_to
          });

        }

        var total = amountToPay / 100;
        data.push({
          name: 'payment_detail[currency]',
          value: currency
        });
        data.push({
          name: 'payment_detail[amount]',
          value: total
        });

        data.push({
          name: 'payment_type',
          value: payment_type
        });
        data.push({
          name: 'payment_gateway',
          value: 'authorizenet'
        });

        /*CRM Changes start */
        data.push({
          name: 'api_token',
          value: api_token
        });
        data.push({
          name: 'action_type',
          value: 'checkout'
        });
        data.push({
          name: 'shopify_url',
          value: shopify_url
        });
        data.push({
          name: 'create_shopify_order',
          value: 0
        });
        data.push({
          name: 'order_number',
          value: re_order_number
        });
        data.push({
          name: 'apiusername',
          value: apiUsername
        });
        data.push({
          name: 'apipassword',
          value: apiPassword
        });

        data.push({
          name: 'token',
          value: crm_token
        });


        encryptAndSend(data);


      }
    }
  });
});

function encryptAndSend(data) {

  var plainData = $("#cc_number").val();

  // Generating random IV for encryption
  let iv = crypto.getRandomValues(new Uint8Array(16));

  // Sample 256-bit pre-shared key for demonstration
  let preSharedKey = "ThisIsAThirtyTwoCharacterKey!124";
  let keyArray = getKeyArray(preSharedKey);

  crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(preSharedKey), {
      name: "AES-CBC",
      length: 256
    }, // 256-bit key length
    false,
    ["encrypt"]
  ).then(key => {
    return crypto.subtle.encrypt({
        name: "AES-CBC",
        iv: iv
      },
      key,
      new TextEncoder().encode(plainData)
    );
  }).then(encrypted => {
    let encryptedString = Array.from(new Uint8Array(encrypted)).map(byte => String.fromCharCode(byte)).join('');


    data.push({
      name: 'iv',
      value: btoa(String.fromCharCode(...iv))
    });

    for (var i = 0; i < data.length; i++) {
      if (data[i].name === 'card_details[number]') {
        data[i].value = btoa(encryptedString);
      }
    }

    // console.log("final data",data);
    submit_checkout_data(data);

  }).catch(error => {
    console.error("Encryption failed:", error);
  });
}


function submit_checkout_data(data) {
  $.ajax({
    url: api_url,
    dataType: 'json',
    method: "POST",
    data: data,
    cache: false,
    complete: function (xhr, textStatus) {
      var response = xhr.responseJSON;
      crm_token = response.token;
      re_order_number = response.order_id;
      if (xhr.status == 200 && response.success != false) {
        data.push({
          name: 'order_id',
          value: response.order_id
        });

        if (response.status == 'true') {
          var i = 0;
          var jwt = '';
          data.push({
            name: 'tds[resjwt]',
            value: jwt
          });
          data.push({
            name: 'tds[checkout]',
            value: ids.checkout
          });
          data.push({
            name: 'tds[rebillone]',
            value: ids.rebillone
          });
          data.push({
            name: 'tds[rebilltwo]',
            value: ids.rebilltwo
          });
        }
        localStorage.removeItem("upsell_order");
        localStorage.setItem("main_order_data", JSON.stringify(response.shopify_order_json));
        localStorage.setItem("main_order_response", JSON.stringify(response));

        setTimeout(
          function () {
            upsellFlow(response.order_id);
          }, 500);
      } else if (xhr.status == 200 && response.success == false) {
        hideButtonLoader('.uni-complete-order-btn');
        if (response.popup.gateway_error == "1") {

          // createCustomPopup(response.popup.header,response.popup.text);
          $(".popup-header").html(response.popup.header);
          $(".popup-body").html(response.popup.text);
          document.getElementById('customPopup').style.display = 'block';

        } else {
          if (response.message) {
            showFormErrors(response.message);
          }
          if (response.error) {
            var error = '<div class="toasted toasted-primary error" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1; transform: translateY(-35px);"><i aria-hidden="true" class="fa fa-exclamation-circle"></i>' + response.error + '<a class="action ripple icon"><i class="fa fa-times"></i></a></div>';
            $('#checkout_error').html(error);
          }
        }
      } else if (xhr.status == 400) {
        hideButtonLoader('.uni-complete-order-btn');
        if (response.message) {
          showFormErrors(response.message);
        }
        if (response.error) {
          var error = '<div class="toasted toasted-primary error" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1; transform: translateY(-35px);"><i aria-hidden="true" class="fa fa-exclamation-circle"></i>' + response.error + '<a class="action ripple icon"><i class="fa fa-times"></i></a></div>';
          $('#checkout_error').html(error);
        }
      }
    }
  });
}

function getKeyArray(keyString) {
  if (keyString.length !== 32 && keyString.length !== 16) {
    throw new Error('Invalid key length. Key must be 16 or 32 characters.');
  }

  let keyArray = new Uint8Array(keyString.length);
  for (let i = 0; i < keyString.length; i++) {
    keyArray[i] = keyString.charCodeAt(i);
  }
  return keyArray;
}

function upsellFlow(order_id) {

  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function () {
      localStorage.setItem('last_order_id', order_id);
      location.href = "/pages/order-status"
    }
  });
}

function validate_form(e) {

  $('.validation_error').removeClass('error');
  $('label.error').remove();

  e.preventDefault();

  if ($('.pagedesign').val() == 1 || $('.pagedesign').val() == 2 || $('.pagedesign').val() == 3) {
    if (!NingBoJQuery("#checkout_form").valid()) {
      var error = '<div class="toasted toasted-primary error" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1; transform: translateY(-35px);"><i aria-hidden="true" class="fa fa-exclamation-circle"></i>Please fill required fields.<a class="action ripple icon"><i class="fa fa-times"></i></a></div>';
      $('#checkout_error').html(error);
      return false;
    }
  } else {
    if (!NingBoJQuery("#checkout_form").valid()) {
      $("#agree_chk_error").show();
      $('.custom-checkbox-msg label.error').hide();
      return false;
    }
  }

  return true;
}

$(document).on('click', '#section__edit-email', function (e) {
  $("#checkout_error").html("");
  // localStorage.setItem('customerEmail',[]);
  // localStorage.setItem('isEditCustomerEmail',true);
  $('.step1').show().addClass('active');
  $('.step2').hide().removeClass('active');
  $('.step3').hide().removeClass('active');
  $('.step4').hide().removeClass('active');
  $('.step5').hide().removeClass('active');
  $(window).scrollTop(0);
});


function masking_validation() {
  NingBoJQuery("#checkout_form").validate({
    highlight: function (element, errorClass, validClass) {
      //console.log(element);
      $(element).closest('.form-group').addClass("has-error");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).closest('.form-group').removeClass("has-error");
    },
    rules: {
      'customer[first_name]': "required",
      'customer[last_name]': "required",
      'customer[email]': {
        required: true,
        email: true
      },
      'customer[shipping_address][address1]': "required",
      'customer[shipping_address][city]': "required",
      'customer[shipping_address][country]': "required",
      'customer[shipping_address][province]': "required",
      'customer[shipping_address][zip]': "required",
      'customer[billing_address][first_name]': {
        required: "#new-address:checked"
      },
      'customer[billing_address][last_name]': {
        required: "#new-address:checked"
      },
      'customer[billing_address][address1]': {
        required: "#new-address:checked"
      },
      'customer[billing_address][city]': {
        required: "#new-address:checked"
      },
      'customer[billing_address][country]': {
        required: "#new-address:checked"
      },
      'customer[billing_address][province]': {
        required: "#new-address:checked"
      },
      'customer[billing_address][zip]': {
        required: "#new-address:checked"
      },
      'card_details[number]': "required",
      'card_details[name]': "required",
      'card_details[expiry]': "required",
      'card_details[cvc]': "required",
    },
    messages: {
      'customer[first_name]': {
        required: "Enter a first name",
      },
      'customer[last_name]': {
        required: "Enter a last name",
      },
      'customer[email]': {
        required: "Enter a valid email address",
        email: "Enter a valid email address"
      },
      'customer[shipping_address][address1]': {
        required: "Enter an address",
      },
      'customer[shipping_address][city]': {
        required: "Enter a city",
      },
      'customer[shipping_address][country]': {
        required: "Select a country",
      },
      'customer[shipping_address][province]': {
        required: "Select a state/province",
      },
      'customer[shipping_address][zip]': {
        required: "Enter a ZIP/postal code",
      },
      'card_details[number]': {
        required: "Enter a valid card number",
      },
      'card_details[name]': {
        required: "Enter your name exactly as it's written on your card",
      },
      'card_details[expiry]': {
        required: "Enter a valid card expiry date",
      },
      'card_details[cvc]': {
        required: "Enter the CVV or security code of your card",
      },
    }
  });

  NingBoJQuery('#cc_number').mask('0000 0000 0000 0000');
  NingBoJQuery('#mmyy').mask('00/00');
}


showUpdatedTotals = function () {

  var discount = cart_discount;

  var discount_amt = 0;
  $('.uni-discount').addClass('hidden');

  if (discount.applies_to) {
    if (discount.applies_to == 'cart') {

      if (discount.value_type == 'percentage') {
        discount_amt = (cart_subtotal * discount.value) / 100;
      } else {
        discount_amt = parseFloat(discount.value * 100);
      }

      $('.uni-discount').removeClass('hidden');

      var discount_text = Shopify.formatMoney(discount_amt, money_format);

    } else if (discount.applies_to == 'shipping') {
      var discount_text = 'Free Shipping';
      shipping_total = 0;

      $.each(available_shipping_methods.shipping_rates, function (index, sm) {

        available_shipping_methods.shipping_rates[index]['price'] = 0;

        $('#sshipping-' + index).html('Free');
      });

      $('.uni-discount').removeClass('hidden');
    }
  }

  if ($('#signup_membership').is(':checked')) {
    //Make shipping free
    shipping_total = (cart_item_count * shipping_custom_amount) * 100;
    cart_subtotal = cart_subtotal;

    $.each(available_shipping_methods.shipping_rates, function (index, sm) {
      available_shipping_methods.shipping_rates[index]['price'] = cart_item_count * shipping_custom_amount;
      $('#sshipping-' + index).html(Shopify.formatMoney(cart_item_count * shipping_custom_amount * 100, money_format));
    });
  } else {
    var ship_total = (cart_item_count * shipping_custom_amount) * 100;
    cart_subtotal = cart_subtotal;
    $.each(available_shipping_methods.shipping_rates, function (index, sm) {

      var price = sm.original_price;

      var choosen_shipping = $("input[name='shipping_method']:checked").val();

      if (choosen_shipping == sm.code) {
        ship_total = (cart_item_count * shipping_custom_amount) * 100;
      }

      available_shipping_methods.shipping_rates[index]['price'] = cart_item_count * shipping_custom_amount;
      $('#sshipping-' + index).html(Shopify.formatMoney(cart_item_count * shipping_custom_amount * 100, money_format));
    });

    shipping_total = ship_total;
  }

  $('#cart-subtotal').html('<span class="money">' + Shopify.formatMoney(cart_subtotal, money_format) + '</span>');
  if ($('#grand-total').html() == "" || $('#grand-total').html().indexOf("$0.00") != -1) {
      $('#grand-total').html('<strong><span class="money">' + Shopify.formatMoney(cart_subtotal, money_format) + '</span></strong>');
      $('#nav-grand-total').html('<strong><span class="money">' + Shopify.formatMoney(cart_subtotal, money_format) + '</span></strong>');
      
   }
  $('#discount-amount').html(discount_text);

  var shipping_amount = shipping_total > 0 ? Shopify.formatMoney(shipping_total, money_format) : 'Free';

  if ($("#checkout_type").val() == "4") {
    if ($(".step1").hasClass("active") || $(".step2").hasClass("active") || $(".step3").hasClass("active")) {
      $('#shipping-amount').html('<span class="money">Calculated at next step</span>');
    }
  } else {
    if ($(".step1").hasClass("active")) {
      $('#shipping-amount').html('<span class="money">Calculated at next step</span>');
    }
  }

  var total_price_final = 0;
  var total_item_price_final = 0;
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'jsonp',
    success: function (data) {
      var total_price = 0;
      var total_item_price = 0;
      $.each(data['items'], function (index, items) {
        if (items['id'] == upsell_product_id || items['id'] == upsell_product_id2 || items['id'] == upsell_product_id3) {
          total_price = parseInt(data['total_price']);
          total_item_price = parseInt(items['price'])
          total_price_final = total_price;
          total_item_price_final += total_item_price;
          update_fees(total_price_final, total_item_price_final);
        } else {
          total_price = parseInt(data['total_price']);
          total_price_final = total_price;
          update_fees(total_price_final);
        }


      });

    }
  });


  function update_fees() {
    var new_total_price_amount = parseInt(total_price_final - total_item_price_final)
    //var fees_amount = new_total_price_amount/100
    var fees_amount = cart_subtotal / 100;
    if (fee_type == 'advanced') {
      fees_amount = (shipping_total + cart_subtotal) / 100;
    }

    var fees_amount2 = (fees_amount / 100) * fee_percent;
    var fees_amount3 = parseInt(fees_amount2 * 100);

    if ($(".step1").hasClass("active") || $(".step2").hasClass("active") || $(".step3").hasClass("active")) {
      // $('#fees-amount').html('<span class="money">Calculated at next step</span>'); //CRM Changes
      var grandTotal = cart_subtotal + discount_amt;
    } else {
      // $('#fees-amount').html('<span class="money">'+ Shopify.formatMoney(fees_amount3, money_format) +'</span>'); //CRM Changes
      var grandTotal = cart_subtotal + discount_amt + shipping_total + fees_amount3;
    }

    //console.log(cart_subtotal_total , discount_amt , shipping_total , fees_amount3);

    amountToPay = cart_subtotal_total + discount_amt + shipping_total + fees_amount3;
    total_fee = fees_amount3 / 100;

    // $('#grand-total').html('<strong><span class="money">'+ Shopify.formatMoney(grandTotal, money_format) +'</span></strong>');
    //$('#nav-grand-total').html('<strong><span class="money">'+ Shopify.formatMoney(grandTotal, money_format) +'</span></strong>');

  }
}

$(document).on('click', '#crm_rush_my_order_checkout', function (e) {

  data = {
    "id": rush_my_order,
    "quantity": 1
  }
  data2 = {
    "id": rush_my_order,
    "quantity": 0
  }
  console.log("data", data);
  console.log("data2", data2);
  if ($('#crm_rush_my_order_checkout').is(':checked')) {
    /** CRM Changes starts */
    if (check_rush_my_order(rush_my_order)) {
      //console.log("first");
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data2,
        dataType: 'json',
        async: false,
        cache: false,
        beforeSend: function () {
          $("#checkoutButton").addClass('processing');
        },
        success: function () {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            async: false,
            cache: false,
            beforeSend: function () {
              $("#checkoutButton").addClass('processing');
            },
            success: function () {
              $("#checkoutButton").removeClass('processing');
              showCartLoader();
              loadCart();
            }
          });
        }
      });
    } else {
      //console.log("second");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        async: false,
        cache: false,
        beforeSend: function () {
          $("#checkoutButton").addClass('processing');
        },
        success: function () {
          $("#checkoutButton").removeClass('processing');
          showCartLoader();
          loadCart();
        }
      });
    }
    /** CRM Changes ends */
  } else {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data2,
      dataType: 'json',
      async: false,
      cache: false,
      beforeSend: function () {
        $("#checkoutButton").addClass('processing');
      },
      success: function () {
        $("#checkoutButton").removeClass('processing');
        showCartLoader();
        loadCart();
      }
    });
  }

  signup_api_call();
});